import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import Customers from "./components/Dashboard/Customers";

import { useSettings } from "../AppContext";
const SETTING = "showDashboard";

function Dashboard() {
  const { resources } = useSettings();
  let resourcesList = [];

  if (resources) {
    resourcesList = resources.filter((item) => item.setting === SETTING);
  }

  const [selected, setSelected] = useState(0);
  const handleTabChange = useCallback((index) => setSelected(index), []);

  let tabs = [
    {
      id: "Customers",
      title: "Customers",
      content: "Customers",
      page: <Customers />,
      panelID: "CustomersPanel",
    },
  ];

  if (resourcesList && resourcesList.length === 1) {
    resourcesList = resourcesList[0].resources;

    if (resourcesList && resourcesList.length > 0) {
      resourcesList = resourcesList.split(",").map((item) => item.trim());
      tabs = tabs.filter((item) => resourcesList.includes(item.id));
    }
  }

  return (
    <Page breadcrumbs={[{ url: "/" }]} title={tabs[selected].title} fullWidth>
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}

export default Dashboard;
